document.addEventListener("DOMContentLoaded", function () {
  const characterImg = document.getElementById("character_img");
  const blurredImg = document.querySelector(".blurred");

  try {
    if (blurredImg && characterImg) {
      if (characterImg.complete) {
        handleImageLoaded();
      } else {
        blurredImg.style.opacity = 1;
        characterImg.addEventListener("load", handleImageLoaded);
      }

      function handleImageLoaded() {
        characterImg.classList.add("loaded");
        setTimeout(() => {
          if (blurredImg) blurredImg.style.opacity = 0;
        }, 500);
      }
    }
  } catch (error) {
    if (characterImg) {
      characterImg.style.opacity = 1;
      characterImg.classList.add("loaded");
    }

    if (blurredImg) {
      blurredImg.style.opacity = 0;
    }
  }

  if (!characterImg) return;

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReducedMotion) return;

  const initialScale = 1;
  const maxScale = 1.05;
  const maxTranslate = 220;
  const scrollDistanceForMaxEffects = 800;
  let ticking = false;

  characterImg.style.transform = `translateY(0px) scale(${initialScale})`;
  characterImg.style.transition = "transform 0.1s ease-out";
  characterImg.style.transformOrigin = "center center";

  /** @returns {void} */
  function updateParallax() {
    const scrollPosition = window.scrollY;
    const scrollProgress = Math.min(1, scrollPosition / scrollDistanceForMaxEffects);
    const scaleValue = initialScale + (maxScale - initialScale) * scrollProgress;
    const translateOffset = Math.min(maxTranslate, scrollPosition * 0.1);

    characterImg.style.transform = `translateY(${translateOffset}px) scale(${scaleValue})`;
    ticking = false;
  }

  /** @returns {void} */
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", function () {
    window.requestAnimationFrame(updateParallax);
  });

  updateParallax();
});
